import * as React from 'react';

export interface EmptyMessageProps {
  message?: string; 
}

const style = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '80vh',
  } as React.CSSProperties,
};
const EmptyMessage = (props: EmptyMessageProps) => {
  const { message = '' } = props;
  return (
    <div style={style.container}>
      <h1>{message}</h1>
    </div>
  );
};

export default EmptyMessage;



// WEBPACK FOOTER //
// ./src/components/common/EmptyMessage.tsx